import { CoreIconButton } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./IconButtonMenuV2.styled";
import { VARIANT_OFFSET, VARIANT_MARGIN } from "./IconButtonMenuV2.constants";
import { MenuV2, type MenuV2Props, type MenuV2ItemProps } from "../MenuV2";
import { Typography } from "../Typography";

export type IconButtonMenuV2Props = Omit<MenuV2Props, "popoverProps"> & {
  variant?: CoreIconButton.Variant;
  popoverProps?: Omit<
    MenuV2Props["popoverProps"],
    "offset" | "maxHeight" | "style"
  >;
};

function IconButtonMenuV2(props: IconButtonMenuV2Props) {
  const {
    variant = CoreIconButton.DEFAULT_VARIANT,
    popoverProps,
    testID = "icon-button-menu",
    ...otherProps
  } = props;

  return (
    <MenuV2
      {...otherProps}
      popoverProps={{
        ...popoverProps,
        offset: VARIANT_OFFSET[variant],
        style: {
          marginLeft: VARIANT_MARGIN[variant],
          marginRight: VARIANT_MARGIN[variant],
        },
      }}
      testID={testID}
    />
  );
}

IconButtonMenuV2.Trigger = MenuV2.Trigger;

IconButtonMenuV2.Content = MenuV2.Content;

type IconButtonMenuV2ItemProps = MenuV2ItemProps & {
  icon?: JSX.Element;
};

IconButtonMenuV2.Item = function IconButtonMenuV2Item(
  props: IconButtonMenuV2ItemProps
) {
  const { icon, children, ...otherProps } = props;

  const { tokens } = useDesignTokens();
  const { iconButtonMenu } = tokens;

  return (
    <MenuV2.Item {...otherProps}>
      {(renderProps) => (
        <S.Content $withIcon={icon !== undefined}>
          {icon && (
            <S.ContentIconWrapper aria-hidden="true">
              {icon}
            </S.ContentIconWrapper>
          )}

          <Typography
            color="inherit"
            variant={iconButtonMenu.menu.item.content.text.typography.variant}
            fontFamily={
              iconButtonMenu.menu.item.content.text.typography.fontFamily
            }
          >
            {typeof children === "function" ? children(renderProps) : children}
          </Typography>
        </S.Content>
      )}
    </MenuV2.Item>
  );
};

export default IconButtonMenuV2;
